export enum Registration {
  A = 'A', // Auto
  M = 'M', // Manual
}
export enum UseYN {
  Y = 'Y',
  N = 'N',
}
